import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { toThunkRejectValue } from "../../../../Common/isRequestCanceled";
import {
  BASE_URL,
  STORE_CREDIT_REPORT,
  STORE_CREDIT_REPORT_COUNT,
} from "../../../../Constants/Config";

const initialState = {
  loading: false,
  StoreCreditReportArr: [],
  StoreCreditReportTotals: {
    total_credit_amount: 0,
    total_debit_amount: 0,
    total_available_balance: 0,
  },
  status: false,
  successMessage: "",
  error: "",
  offset: 0,
  limit: 10,
  hasMore: true,

  countLoading: false,
  countData: 0,
};

let abortStoreCreditReport = null;
let abortStoreCreditReportCount = null;

export const fetchStoreCreditReportArr = createAsyncThunk(
  "StoreCreditReport/fetchStoreCreditReportArr",
  async (data, { rejectWithValue }) => {
    try {
      if (abortStoreCreditReport) {
        abortStoreCreditReport.abort();
      }

      abortStoreCreditReport = new AbortController();
      const signal = abortStoreCreditReport.signal;

      const { token, ...dataNew } = data;
      const res = await axios.post(BASE_URL + STORE_CREDIT_REPORT, dataNew, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
        signal,
      });
      // console.log(res.data);
      if (res.data.status === true) {
        const arr = res.data.store_credit_data;
        const status = res.data.status;
        const totalCustomerCount = res.data.total_count;
        const totalCreditAmount = res.data.total_credit_amount;
        const totalDebitAmount = res.data.total_debit_amount;
        const totalAvailableBalance = res.data.total_available_balance;

        return { arr, status, totalCustomerCount, totalCreditAmount, totalDebitAmount, totalAvailableBalance };
      } else if (res.data.status === false) {
        const arr = [];
        const status = false;
        const totalCustomerCount = 0;
        const totalCreditAmount = 0;
        const totalDebitAmount = 0;
        const totalAvailableBalance = 0;
        return { arr, status, totalCustomerCount, totalCreditAmount, totalDebitAmount, totalAvailableBalance };
      }
    } catch (error) {
      const customError = {
        message: toThunkRejectValue(error).message,
        status: toThunkRejectValue(error).status,
        data: error.response ? error.response.data : null,
      };
      return rejectWithValue(customError);
    }
  }
);

export const fetchStoreCreditReportCount = createAsyncThunk(
  "products/fetchStoreCreditReportCount",
  async (payload, { rejectWithValue }) => {
    const { token, ...dataNew } = payload;
    try {
      if (abortStoreCreditReportCount) {
        abortStoreCreditReportCount.abort();
      }

      abortStoreCreditReportCount = new AbortController();
      const signal = abortStoreCreditReportCount.signal;

      const response = await axios.post(
        BASE_URL + STORE_CREDIT_REPORT_COUNT,
        dataNew,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
          signal,
        }
      );
      if (response?.data?.status) {
        return response?.data?.total_count;
      }
    } catch (error) {
      // throw new Error("Internal Server Error");
      const customError = {
        message: toThunkRejectValue(error).message,
        status: toThunkRejectValue(error).status,
        data: error.response ? error.response.data : null,
      };
      return rejectWithValue(customError);
    }
  }
);

const StoreCreditReportSlice = createSlice({
  name: "StoreCreditReport",
  initialState,
  reducers: {
    emptyStoreCreditReportData: (state, action) => {
      state.loading = false;
      state.StoreCreditReportArr = [];
      state.StoreCreditReportTotals = {
        total_credit_amount: 0,
        total_debit_amount: 0,
        total_available_balance: 0,
      };
      state.status = false;
      state.successMessage = "";
      state.error = "";
      state.offset = 0;
      state.limit = 10;
      state.hasMore = true;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchStoreCreditReportArr.pending, (state) => {
      state.loading = true;
      state.StoreCreditReportArr = [];
      state.StoreCreditReportTotals = {
        total_credit_amount: 0,
        total_debit_amount: 0,
        total_available_balance: 0,
      };
    });
    builder.addCase(fetchStoreCreditReportArr.fulfilled, (state, action) => {
      state.loading = false;
      state.StoreCreditReportArr = action.payload.arr;
      state.StoreCreditReportTotals = {
        total_credit_amount: action.payload.totalCreditAmount,
        total_debit_amount: action.payload.totalDebitAmount,
        total_available_balance: action.payload.totalAvailableBalance,
      };
      state.status = action.payload.status;
      state.error = "";

      // state.hasMore =
      //   +action?.payload?.totalCustomerCount >
      //   +state?.StoreCreditReportArr?.length;

      // if (
      //   +action?.payload?.totalCustomerCount >
      //   +state?.StoreCreditReportArr?.length
      // ) {
      //   state.limit += 10; // Increment only if there are new products
      // }
      // if (Array.isArray(action?.payload?.arr)) {
      //   state.StoreCreditReportArr = action.payload.arr;
      // }
    });
    builder.addCase(fetchStoreCreditReportArr.rejected, (state, action) => {
      state.loading = false;
      state.StoreCreditReportArr = [];
      state.StoreCreditReportTotals = {
        total_credit_amount: 0,
        total_debit_amount: 0,
        total_available_balance: 0,
      };
      state.error = action.error.message;
    });

    builder.addCase(fetchStoreCreditReportCount.pending, (state) => {
      state.countLoading = true;
      state.countData = [];
    });
    builder.addCase(fetchStoreCreditReportCount.fulfilled, (state, action) => {
      state.countLoading = false;
      state.countData = action.payload;
    });
    builder.addCase(fetchStoreCreditReportCount.rejected, (state, action) => {
      state.countLoading = false;
      state.countData = [];
    });
  },
});
export const { emptyStoreCreditReportData } = StoreCreditReportSlice.actions;

export default StoreCreditReportSlice.reducer;
